import { render } from "./App.vue?vue&type=template&id=77a5ce66"
const script = {}

import "./App.vue?vue&type=style&index=0&id=77a5ce66&lang=css"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__